import emptyMembers1x from "./images/emptyMembers.png";
import emptyMembers2x from "./images/emptyMembers@2x.png";
import emptyMembers3x from "./images/emptyMembers@3x.png";
import emptyMembersDark1x from "./images/emptyMembersDark.png";
import emptyMembersDark2x from "./images/emptyMembersDark@2x.png";
import emptyMembersDark3x from "./images/emptyMembersDark@3x.png";

export const EMPTY_MEMBER_IMAGES = {
  light: {
    thumbnail: emptyMembers1x,
    small: emptyMembers2x,
    medium: emptyMembers3x,
    large: emptyMembers3x,
  },
  dark: {
    thumbnail: emptyMembersDark1x,
    small: emptyMembersDark2x,
    medium: emptyMembersDark3x,
    large: emptyMembersDark3x,
  },
};
